function componentIntro() {
  if ($('.js-intro-btn').length) {
    $('.js-intro-btn').on('click', function () {
      // $('.img--full intro__image--classic').hide()
      $('.intro__logo-image').hide()
      $('.intro__image-block').append(
        '<img class="img--responsive img--full intro__image intro__image--boom intro__image--boom-last" src="images/thor-boom.webp?v=2" alt="Thor boom">',
      )

      loadIndexContent()
    })
  }
}

function loadIndexContent() {
  $('.intro__btn').hide()

  var videoTemplate = `
			<video id="video-hobby" width="320" height="240" mute="mute" loop="loop" playsinline="playsinline">
				<source src="video/kniha.mp4" type="video/mp4" />
			</video>
		`
  $('#video-block').prepend(videoTemplate)

  // VideoHobby
  componentVideoHobby()

  setTimeout(() => {
    $('body').removeClass('is-intro-active')
  }, 1500)

  setTimeout(() => {
    $('.intro').remove()
  }, 1500)

  setTimeout(() => {
    $('.hero-index-section').addClass('is-active')
  }, 2000)
}

function loadImagesSection() {
  if ($('.js-slider-about-me').length) {
    $('.js-slider-about-me .swiper-slide img').each(function () {
      var img = $(this)
      var imgDataSrc = img.attr('data-src')
      img.attr('src', imgDataSrc)
    })
  }

  if ($('.work-tablet-hand-swipe__hand-icon').length) {
    $('.work-tablet-hand-swipe__hand-icon img').attr(
      'src',
      $('.work-tablet-hand-swipe__hand-icon img').attr('data-src'),
    )
  }

  if ($('.yellow-bg-data').length) {
    $('.yellow-bg-data').attr('src', $('.yellow-bg-data').attr('data-src'))
  }

  if ($('.instagram-bg-data').length) {
    $('.instagram-bg-data').attr(
      'src',
      $('.instagram-bg-data').attr('data-src'),
    )
  }

  if ($('#hero-index-section').length) {
    $('.hero-thor-data').attr('src', $('.hero-thor-data').attr('data-src'))
    $('.hero-thor-dots').attr('src', $('.hero-thor-dots').attr('data-src'))
    $('.hero-bubble-dots-data').attr(
      'src',
      $('.hero-bubble-dots-data').attr('data-src'),
    )
    $('.hero-bubble-data').attr('src', $('.hero-bubble-data').attr('data-src'))
    $('.hero-bubble-text-data').attr(
      'src',
      $('.hero-bubble-text-data').attr('data-src'),
    )

    $('.about-me-bg-data-top').attr(
      'src',
      $('.about-me-bg-data-top').attr('data-src'),
    )
    $('.about-me-bg-data-bottom').attr(
      'src',
      $('.about-me-bg-data-bottom').attr('data-src'),
    )
  }

  if ($('.arrow-right-data').length) {
    $('.arrow-right-data').attr('src', $('.arrow-right-data').attr('data-src'))
  }

  if ($('.footer-dots').length) {
    $('.footer-dots').attr('src', $('.footer-dots').attr('data-src'))
  }

  if ($('.header-dots').length) {
    $('.header-dots').attr('src', $('.header-dots').attr('data-src'))
  }

  if ($('.btn-dots-data').length) {
    $('.btn-dots-data').attr('src', $('.btn-dots-data').attr('data-src'))
  }

  if ($('.slider-window-data').length) {
    $('.slider-window-data').attr(
      'src',
      $('.slider-window-data').attr('data-src'),
    )
  }

  if ($('.blue-middle-data').length) {
    $('.blue-middle-data').attr('src', $('.blue-middle-data').attr('data-src'))
  }

  if ($('.blue-bg-data').length) {
    $('.blue-bg-data').attr('src', $('.blue-bg-data').attr('data-src'))
  }

  if ($('.work-tablet-data').length) {
    $('.work-tablet-data').attr('src', $('.work-tablet-data').attr('data-src'))
  }

  if ($('.arrow-right-data').length) {
    $('.arrow-right-data').attr('src', $('.arrow-right-data').attr('data-src'))
  }

  if ($('.work-palec-data').length) {
    $('.work-palec-data').attr('src', $('.work-palec-data').attr('data-src'))
  }

  if ($('.linkedin-bg').length) {
    $('.linkedin-bg').attr('src', $('.linkedin-bg').attr('data-src'))
  }

  if ($('.linkedin-bg-purple').length) {
    $('.linkedin-bg-purple').attr(
      'src',
      $('.linkedin-bg-purple').attr('data-src'),
    )
  }

  if ($('.instagram-bg-block-data').length) {
    $('.instagram-bg-block-data').attr(
      'src',
      $('.instagram-bg-block-data').attr('data-src'),
    )
  }

  if ($('.instagram-bg-purple').length) {
    $('.instagram-bg-purple').attr(
      'src',
      $('.instagram-bg-purple').attr('data-src'),
    )
  }

  if ($('.facebook-bg').length) {
    $('.facebook-bg').attr('src', $('.facebook-bg').attr('data-src'))
  }

  if ($('.facebook-bg-purple').length) {
    $('.facebook-bg-purple').attr(
      'src',
      $('.facebook-bg-purple').attr('data-src'),
    )
  }

  if ($('.instagram-block').length) {
    $('.js-slider-instagram .swiper-slide').each(function () {
      var img = $(this).find('img')
      var imgDataSrc = img.attr('data-src')
      img.attr('src', imgDataSrc)
    })
  }

  if ($('.gold-partner').length) {
    $('.gold-partner').attr('src', $('.gold-partner').attr('data-src'))
  }
}
